import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { StepThree } from './components/StepThree';
import { StepOne } from './components/StepOne';
import { StepTwo } from './components/StepTwo';
import { StepFour } from './components/StepFour';
import { StepFive } from './components/StepFive';
import { StepSix } from './components/StepSix';
import { StepSeven } from './components/StepSeven';
import { StepEight } from './components/StepEight';
import { BriefingOverview } from './components/BriefingOverview';

export const CampaignCreateRoutes = () => (
    <Routes>
        <Route path=":id/step1" element={<StepOne />} />
        <Route path=":id/step2" element={<StepTwo />} />
        <Route path=":id/step3" element={<StepThree />} />
        <Route path=":id/step4" element={<StepFour />} />
        <Route path=":id/step5" element={<StepFive />} />
        <Route path=":id/step6" element={<StepSix />} />
        <Route path=":id/step7" element={<StepSeven />} />
        <Route path=":id/step8" element={<StepEight />} />
        <Route path=":id/overview" element={<BriefingOverview />} />
        <Route path="/" element={<Navigate to="/brand/dashboard" replace />} />
    </Routes>
);
